import { handleGetRequest } from "../../services/GetTemplate";
import { SETBRANCHAUTHFORMDATA_SUCCESS, SETBRANCHAUTHFORMDATA_ERROR, SETBRANCHAUTHFORMDATA_NULL_SUCCESS, SETEDITFLAG_SUCCESS, GETBRANCHAUTHORIZATION_SUCCESS, GETBRANCHAUTHORIZATION_ERROR, GETBRANCHAUTHFURTHERDETAILS_SUCCESS, GETBRANCHAUTHFURTHERDETAILS_ERROR } from "../slices/branchSlice";

export const SetBranchAuthFormAction = (data) => async (dispatch) => {
    if (data) {
        dispatch(SETBRANCHAUTHFORMDATA_SUCCESS(data));
    } else {
        dispatch(SETBRANCHAUTHFORMDATA_ERROR("Error"));
    }
};
export const SetBranchAuthDetailsFormToNullAction = () => async (dispatch) => {
    dispatch(SETBRANCHAUTHFORMDATA_NULL_SUCCESS(null));
};

export const SetEditFlagAction = (data) => async (dispatch) => {
    dispatch(SETEDITFLAG_SUCCESS(data));
};

//Get Branch  Authorization
export const GetBranchAuthorizationAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETBRANCHAUTHORIZATION_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETBRANCHAUTHORIZATION_ERROR("Error"));
        return res?.responsecode;
    }
};
//Get Branch Further Details
export const GetBranchAuthFurtherDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETBRANCHAUTHFURTHERDETAILS_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETBRANCHAUTHFURTHERDETAILS_ERROR("Error"));
        return res?.responsecode;
    }
};
